/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AttachmentCategory } from '../models/AttachmentCategory';
import type { AttachmentResponse } from '../models/AttachmentResponse';
import type { AttachmentResponseWithSiteRange } from '../models/AttachmentResponseWithSiteRange';
import type { Body_Attachment_Routes_update_contractor_attachment } from '../models/Body_Attachment_Routes_update_contractor_attachment';
import type { Body_Attachment_Routes_update_contractor_logo } from '../models/Body_Attachment_Routes_update_contractor_logo';
import type { Body_Attachment_Routes_update_platform_attachment } from '../models/Body_Attachment_Routes_update_platform_attachment';
import type { Body_Attachment_Routes_upload_attachments } from '../models/Body_Attachment_Routes_upload_attachments';
import type { Body_Attachment_Routes_upload_contractor_logo } from '../models/Body_Attachment_Routes_upload_contractor_logo';
import type { Body_Attachment_Routes_upload_document_attachment } from '../models/Body_Attachment_Routes_upload_document_attachment';
import type { DocumentAttachmentResponse } from '../models/DocumentAttachmentResponse';
import type { DocumentTemplateType } from '../models/DocumentTemplateType';
import type { ExtractionStatusRequest } from '../models/ExtractionStatusRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AttachmentRoutesRepository {
  /**
   * Fetch All Attachments
   * Lists all attachments.
   * @returns AttachmentResponse Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesFetchAllAttachments({
    jobId,
    includeUrl = false,
    category,
    authorization,
  }: {
    jobId: string,
    includeUrl?: boolean,
    category?: (AttachmentCategory | null),
    authorization?: string,
  }): CancelablePromise<Array<AttachmentResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attachments/job/{job_id}',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      query: {
        'include_url': includeUrl,
        'category': category,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upload Attachments
   * Upload file to GCS.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesUploadAttachments({
    jobId,
    formData,
    addGeotag = false,
    addTimestamp = false,
    includeUrl = false,
    authorization,
  }: {
    jobId: string,
    formData: Body_Attachment_Routes_upload_attachments,
    addGeotag?: boolean,
    addTimestamp?: boolean,
    includeUrl?: boolean,
    authorization?: string,
  }): CancelablePromise<(Array<AttachmentResponse> | Array<AttachmentResponseWithSiteRange>)> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attachments/job/{job_id}',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      query: {
        'add_geotag': addGeotag,
        'add_timestamp': addTimestamp,
        'include_url': includeUrl,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        422: `Unprocessable Entity`,
      },
    });
  }
  /**
   * Upload Contractor Logo
   * Upload file to GCS.
   * @returns AttachmentResponse Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesUploadContractorLogo({
    formData,
    authorization,
  }: {
    formData: Body_Attachment_Routes_upload_contractor_logo,
    authorization?: string,
  }): CancelablePromise<AttachmentResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attachments/contractors/logo',
      headers: {
        'authorization': authorization,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        422: `Unprocessable Entity`,
      },
    });
  }
  /**
   * Update Contractor Logo
   * Upload file to GCS.
   * @returns AttachmentResponse Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesUpdateContractorLogo({
    contractorId,
    formData,
    authorization,
  }: {
    contractorId: string,
    formData: Body_Attachment_Routes_update_contractor_logo,
    authorization?: string,
  }): CancelablePromise<AttachmentResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/attachments/contractors/logo/{contractor_id}',
      path: {
        'contractor_id': contractorId,
      },
      headers: {
        'authorization': authorization,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        422: `Unprocessable Entity`,
      },
    });
  }
  /**
   * Update Contractor Attachment
   * Upload/replace a contractor-level default attachment (e.g. default plumbing/oil burner license/W9).
   * @returns AttachmentResponse Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesUpdateContractorAttachment({
    contractorId,
    attachmentCategory,
    formData,
    authorization,
  }: {
    contractorId: string,
    attachmentCategory: 'contractor_default_plumbing_license' | 'contractor_default_oil_burner_license' | 'contractor_default_w9',
    formData: Body_Attachment_Routes_update_contractor_attachment,
    authorization?: string,
  }): CancelablePromise<AttachmentResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/attachments/contractors/{contractor_id}/attachments/{attachment_category}',
      path: {
        'contractor_id': contractorId,
        'attachment_category': attachmentCategory,
      },
      headers: {
        'authorization': authorization,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        422: `Unprocessable Entity`,
      },
    });
  }
  /**
   * Fetch Platform Attachment
   * Get a platform-wide attachment (e.g. Sealed's own W9) -- not tied to any job or contractor.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesFetchPlatformAttachment({
    attachmentCategory,
    authorization,
  }: {
    attachmentCategory: string,
    authorization?: string,
  }): CancelablePromise<(AttachmentResponse | null)> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attachments/platform/{attachment_category}',
      path: {
        'attachment_category': attachmentCategory,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Platform Attachment
   * Upload/replace a platform-wide attachment (e.g. Sealed's own W9) -- not tied to any job or contractor.
   * @returns AttachmentResponse Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesUpdatePlatformAttachment({
    attachmentCategory,
    formData,
    authorization,
  }: {
    attachmentCategory: string,
    formData: Body_Attachment_Routes_update_platform_attachment,
    authorization?: string,
  }): CancelablePromise<AttachmentResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/attachments/platform/{attachment_category}',
      path: {
        'attachment_category': attachmentCategory,
      },
      headers: {
        'authorization': authorization,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        422: `Unprocessable Entity`,
      },
    });
  }
  /**
   * Get Extraction Status
   * Returns extraction results.
   *
   * The request body maps each question name to its field and optional filters.
   * Results in the response are keyed by the same question names.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesGetExtractionStatus({
    jobId,
    attachmentCategory,
    requestBody,
    authorization,
  }: {
    jobId: string,
    attachmentCategory: AttachmentCategory,
    requestBody: ExtractionStatusRequest,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attachments/extraction-status/{job_id}/{attachment_category}',
      path: {
        'job_id': jobId,
        'attachment_category': attachmentCategory,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Rerun Attachment Extraction
   * Rerun Gemini field extraction for an attachment.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesRerunAttachmentExtraction({
    attachmentId,
    authorization,
  }: {
    attachmentId: string,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attachments/{attachment_id}/rerun-extraction',
      path: {
        'attachment_id': attachmentId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Attachment
   * Get a single attachment by ID.
   * @returns AttachmentResponse Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesGetAttachment({
    id,
    includeUrl = false,
    isHistoryRecord = false,
    authorization,
  }: {
    id: string,
    includeUrl?: boolean,
    isHistoryRecord?: boolean,
    authorization?: string,
  }): CancelablePromise<AttachmentResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attachments/{id}',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      query: {
        'include_url': includeUrl,
        'is_history_record': isHistoryRecord,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Attachment
   * Delete file from GCS.
   * @returns void
   * @throws ApiError
   */
  public static attachmentRoutesDeleteAttachment({
    id,
    authorization,
  }: {
    id: string,
    authorization?: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/attachments/{id}',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Downloadfiles
   * Downloads multiple attachments in a zip.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesDownloadFiles({
    requestBody,
    authorization,
  }: {
    requestBody: Array<string>,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attachments/download/files',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upload Document Attachment
   * Upload file to GCS. Locate the existing attachment (with a document association) and update it with GCS info.
   * @returns DocumentAttachmentResponse Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesUploadDocumentAttachment({
    jobId,
    attachmentId,
    formData,
    authorization,
  }: {
    jobId: string,
    attachmentId: string,
    formData: Body_Attachment_Routes_upload_document_attachment,
    authorization?: string,
  }): CancelablePromise<DocumentAttachmentResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/attachments/document/{job_id}/{attachment_id}',
      path: {
        'job_id': jobId,
        'attachment_id': attachmentId,
      },
      headers: {
        'authorization': authorization,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        422: `Unprocessable Entity`,
      },
    });
  }
  /**
   * Download Document Attachment
   * Download the document from the document vendor.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesDownloadDocumentAttachment({
    jobId,
    attachmentId,
    authorization,
  }: {
    jobId: string,
    attachmentId: string,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attachments/document/{job_id}/{attachment_id}',
      path: {
        'job_id': jobId,
        'attachment_id': attachmentId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Document Attachment
   * Delete file from GCS.
   * @returns DocumentAttachmentResponse Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesDeleteDocumentAttachment({
    attachmentId,
    authorization,
  }: {
    attachmentId: string,
    authorization?: string,
  }): CancelablePromise<DocumentAttachmentResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/attachments/document/{attachment_id}',
      path: {
        'attachment_id': attachmentId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Document Update Rebuild
   * Updates or Rebuilds a document with latest data.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesDocumentUpdateRebuild({
    jobId,
    templateType,
    rebuild = false,
    authorization,
  }: {
    jobId: string,
    templateType: DocumentTemplateType,
    rebuild?: boolean,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attachments/document/update/{job_id}/{template_type}',
      path: {
        'job_id': jobId,
        'template_type': templateType,
      },
      headers: {
        'authorization': authorization,
      },
      query: {
        'rebuild': rebuild,
      },
      errors: {
        422: `Validation Error`,
        502: `Bad Gateway`,
      },
    });
  }
  /**
   * Document No Signature Update Rebuild
   * Updates or Rebuilds a document with latest data.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesDocumentNoSignatureUpdateRebuild({
    jobId,
    templateType,
    rebuild = false,
    authorization,
  }: {
    jobId: string,
    templateType: DocumentTemplateType,
    rebuild?: boolean,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attachments/document/update-no-signature/{job_id}/{template_type}',
      path: {
        'job_id': jobId,
        'template_type': templateType,
      },
      headers: {
        'authorization': authorization,
      },
      query: {
        'rebuild': rebuild,
      },
      errors: {
        409: `Conflict`,
        422: `Validation Error`,
        502: `Bad Gateway`,
      },
    });
  }
  /**
   * Send Document Link For Signature
   * Send document links for signature.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static attachmentRoutesSendDocumentLinkForSignature({
    jobId,
    templateType,
    authorization,
  }: {
    jobId: string,
    templateType: DocumentTemplateType,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attachments/document/send/{job_id}/{template_type}',
      path: {
        'job_id': jobId,
        'template_type': templateType,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
